import {
  findFriendOnSquad,
  isMessagingBlockedWithPlayer,
} from './messagingPolicy';
import { blockedOpenChatMessage } from './errors';

/**
 * Open private chat with a squad friend (App-level guard + notifications).
 * @returns {boolean} true if chat was opened
 */
export function tryOpenPrivateChat({ friendId, friends, onOpen, onNotify }) {
  const friend = findFriendOnSquad(friendId, friends);
  if (!friend) {
    onNotify?.('You can only chat with friends on your squad.');
    return false;
  }
  if (isMessagingBlockedWithPlayer(friendId, friends)) {
    onNotify?.(blockedOpenChatMessage(friend));
    return false;
  }
  onOpen?.(friend);
  return true;
}
